/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {ChannelHeaderIcon} from '@app/components/channel/channel_header_components/ChannelHeaderIcon';
import {InboxIcon} from '@app/components/icons/InboxIcon';
import {InboxPopout} from '@app/components/popouts/InboxPopout';
import {Popout} from '@app/components/uikit/popout/Popout';
import {usePopout} from '@app/hooks/usePopout';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

export const InboxButton = observer(() => {
	const {t} = useLingui();
	const {isOpen, openProps} = usePopout('inbox');

	return (
		<Popout {...openProps} render={() => <InboxPopout />} position="bottom-end" subscribeTo="INBOX_OPEN">
			<ChannelHeaderIcon icon={InboxIcon} label={t`Inbox`} isSelected={isOpen} keybindAction="toggle_mentions_popout" />
		</Popout>
	);
});
